/**
* @name: use-sel-color
* @author: weiyong
* @date: 2023-04-01 10:54
* @description：use-sel-color
* @update: 2023-04-01 10:54
*/
<template>
  <div class="layout-item" style="position: relative;">
    <div class="item-type-sign" style="width:80px;margin-right: 0">
      <div class="color-div" @click.stop="changSketch"
           :style="{ backgroundColor: sketchBgColor, width: '84px', border: '1px solid #dfdfdf' }"></div>
          <span class="layout-label changSketch" @click.stop="changSketch">
           {{ t('自定义') }}
          </span>
      <span class="layoutItem-type-sign-icon"><check-outlined/></span>
    </div>
    <Sketch style="position:absolute;z-index: 99999" v-model="colors" @changButton="change" :show="showSketch"></Sketch>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "use-sel-color",
});
</script>

<script lang="ts" setup>
import {CheckOutlined} from "@ant-design/icons-vue";
import {Sketch} from '@ans1998/vue3-color';
import {useDesign} from "@/hooks/web/useDesign";
import {useSketchColor} from "@/hooks/component/useSketchColor";
import {useI18n} from "vue-i18n";

const {t} = useI18n();
const emits = defineEmits(['selItem'])
const selItem = (item) => {
  emits('selItem', item);
}
const {showSketch, colors, sketchBgColor, changSketch,closePanel} = useSketchColor(selItem,emits);

const change = (item) => {
  showSketch.value=false;
}
const {prefixCls} = useDesign('use-sel-color');
defineExpose({closePanel})
</script>

<style type="text/css" lang="less">
.changSketch {
  position: absolute;
  top: 10px;
  color: #FFF;
  left: 25px;
}
</style>
